<template>
  <div id="Quality">
    <TopNav></TopNav>
    <div class="pageCon">
      <LeftNav></LeftNav>
      <div class="page">
        <Breadcrumb></Breadcrumb>
        <component :is="comName" :comName.sync="comName"></component>
      </div>
    </div>
  </div>
</template>
<script>
import TopNav from "@/components/TopNav.vue";
import LeftNav from "@/components/LeftNav.vue";
import BasicsGranary from "@/views/manage/basics/Granary.vue";
import BasicsGranaryAdd from "@/views/manage/basics/GranaryAdd.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Report from "@/views/quality/Report.vue";
import ReportAdd from "@/views/quality/ReportAdd.vue";
import BarncardNew from "@/views/quality/barncard/New.vue";
import BarncardOld from "@/views/quality/barncard/Old.vue";
import BarncardDetail from "@/views/quality/barncard/Detail.vue";
import BarncardAdd from "@/views/quality/barncard/Add.vue";
import Standbook from "@/views/quality/standbook/Standbook.vue";
import StandbookDetail from "@/views/quality/standbook/Detail.vue";
import Archives from "@/views/quality/Archives.vue";
import ArchivesDetail from "@/views/quality/ArchivesDetail.vue";
import TestitemsItems from "@/views/quality/testitems/Items.vue";
import TestitemsTemp from "@/views/quality/testitems/Temp.vue";
import TestitemsTempdetail from "@/views/quality/testitems/Tempdetail.vue";
import TestitemsIncrease from "@/views/quality/testitems/Increase.vue";
import TestitemsDetail from "@/views/quality/testitems/Detail.vue";
import Qualityfile from "@/views/quality/qualityfile.vue";


export default {
  name: "Quality",
  components: {
    TopNav,
    LeftNav,
    BasicsGranary,
    BasicsGranaryAdd,
    Breadcrumb,
    BarncardOld,
    BarncardDetail,
    BarncardAdd,
    BarncardNew,
    Report,
    ReportAdd,
    Standbook,
    StandbookDetail,
    Archives,
    ArchivesDetail,
    TestitemsItems,
    TestitemsTemp,
    TestitemsTempdetail,
    TestitemsIncrease,
    TestitemsDetail,
    Qualityfile
  },
  data() {
    return {
      comName: "Report",
    };
  },
  methods: {},
  watch: {
    "$store.state.leftNav": {
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          console.log("newVal", newVal);
          this.comName = newVal;
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
#Quality {
  width: 100%;
  height: 100%;
  .pageCon {
    display: flex;
    justify-content: space-between;
    .page {
      flex: 1;
      height: calc(100vh - 116px);
    }
  }
}
</style>
